import React, {forwardRef, Suspense} from "react";
import "./button.css";

export const Button = forwardRef(function Button ({
                                                      children,
                                                      type="primary",
                                                      isReversed=false,
                                                      postIcon=null,
                                                      preIcon=null,
                                                        ...props
                                                  },ref) {

    return (
        <button className={`button ${isReversed && "isReversed"} ${type}`} {...props} ref={ref}>
            {preIcon}
            <span>{children}</span>
            {postIcon}
        </button>
    );
})

export default Button